import React, { useCallback } from "react";
import { GlobalHeader as GlobalHeaderBase } from "@ubnt/store.core/lib/components/Header/Header";

import { useSiteSettings } from "../../context/SiteSettingsContext/context";
import * as S from "./Header.styles";

import { AccountMenu } from "@ubnt/store.core/lib/components/Header/AccountMenu";

export const GlobalHeader = () => {
  const { routes, onLinkClick } = useSiteSettings();

  // #############################################################################
  // Cart
  // #############################################################################
  const onCartClick = useCallback(() => {
    window.location.href = routes.store.homepage();
  }, [routes]);

  // #############################################################################
  // Custom menu item action
  // #############################################################################
  const onMenuItemLinkClick = useCallback(
    (e, item) => {
      onLinkClick(e, item.url);
    },
    [onLinkClick],
  );

  // #############################################################################
  // Render
  // #############################################################################
  return (
    <S.RemoveAnchorUnderline>
      <GlobalHeaderBase
        motif="dark"
        sticky
        stickyCarousel
        renderImage={({ src, alt, height, width, onLoad, onError }) => (
          <img
            src={src}
            alt={alt ?? undefined}
            height={height}
            width={width}
            onLoad={onLoad}
            onError={onError}
          />
        )}
        onCartClick={onCartClick}
        onMenuItemLinkClick={onMenuItemLinkClick}
        onMenuSubItemLinkClick={onMenuItemLinkClick}
        accountMenu={<AccountMenu account={{}} />}
      />
    </S.RemoveAnchorUnderline>
  );
};
